export default (dict: any, fields: any) => {
  if (fields === null || typeof fields === 'undefined') {
    return dict;
  }
  if (fields.length === 0) {
    const error = { name: 'unknown field', message: 'No field specified.' };
    throw error;
  }
  return fields.reduce(
    (acc: any, field: any) => ({
      ...acc,
      [field]: dict[field],
    }),
    {},
  );
};
